module.exports = __webpack_public_path__ + "img/github.0290f7d8.png";